import { render, staticRenderFns } from "./FAQQuestionList.vue?vue&type=template&id=60d12fa8&scoped=true"
import script from "./FAQQuestionList.vue?vue&type=script&lang=js"
export * from "./FAQQuestionList.vue?vue&type=script&lang=js"
import style0 from "./FAQQuestionList.vue?vue&type=style&index=0&id=60d12fa8&prod&lang=css"
import style1 from "./FAQQuestionList.vue?vue&type=style&index=1&id=60d12fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d12fa8",
  null
  
)

export default component.exports